import { render, staticRenderFns } from "./sampleList.vue?vue&type=template&id=25b90a16&scoped=true"
import script from "./sampleList.vue?vue&type=script&lang=js"
export * from "./sampleList.vue?vue&type=script&lang=js"
import style0 from "./sampleList.vue?vue&type=style&index=0&id=25b90a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b90a16",
  null
  
)

export default component.exports